const initialState = {
  inboxSyncComplete: false
}

const SET_INBOX_SYNC_COMPLETE = 'SET_INBOX_SYNC_COMPLETE'
const CLEAR_INBOX_SYNC_COMPLETE = 'CLEAR_INBOX_SYNC_COMPLETE'

export const setInboxSyncComplete = () => ({ type: SET_INBOX_SYNC_COMPLETE })
export const clearInboxSyncComplete = () => ({ type: CLEAR_INBOX_SYNC_COMPLETE })

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INBOX_SYNC_COMPLETE:
      return { ...state, inboxSyncComplete: true }
    case CLEAR_INBOX_SYNC_COMPLETE:
      return { ...state, inboxSyncComplete: false }
    default:
      return state
  }
}
